import api from './api';
import { API_ENDPOINTS } from '../config/apiConfig';

// Create a new demo request (public)
export const createDemoRequest = async (demoData) => {
  try {
    const response = await api.post(API_ENDPOINTS.DEMO_REQUESTS.BASE, demoData);
    return response.data;
  } catch (error) {
    throw error.response?.data || { error: 'Failed to submit demo request' };
  }
};

// Get available time slots for a specific date (public)
export const getAvailableTimeSlots = async (date) => {
  try {
    const response = await api.get(API_ENDPOINTS.DEMO_REQUESTS.AVAILABLE_SLOTS, {
      params: { date }
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || { error: 'Failed to fetch available time slots' };
  }
};

// Get all demo requests (admin only)
export const getAllDemoRequests = async (params = {}) => {
  try {
    const response = await api.get(API_ENDPOINTS.DEMO_REQUESTS.BASE, { params });
    return response.data;
  } catch (error) {
    throw error.response?.data || { error: 'Failed to fetch demo requests' };
  }
};

// Get a single demo request by ID (admin only)
export const getDemoRequestById = async (id) => {
  try {
    const response = await api.get(API_ENDPOINTS.DEMO_REQUESTS.BY_ID(id));
    return response.data;
  } catch (error) {
    throw error.response?.data || { error: 'Failed to fetch demo request' };
  }
};

// Update demo request (admin only)
export const updateDemoRequest = async (id, updateData) => {
  try {
    const response = await api.put(API_ENDPOINTS.DEMO_REQUESTS.BY_ID(id), updateData);
    return response.data;
  } catch (error) {
    throw error.response?.data || { error: 'Failed to update demo request' };
  }
};

// Delete demo request (admin only)
export const deleteDemoRequest = async (id) => {
  try {
    const response = await api.delete(API_ENDPOINTS.DEMO_REQUESTS.BY_ID(id));
    return response.data;
  } catch (error) {
    throw error.response?.data || { error: 'Failed to delete demo request' };
  }
};

// Get demo request statistics (admin only)
export const getDemoRequestStats = async () => {
  try {
    const response = await api.get(API_ENDPOINTS.DEMO_REQUESTS.STATS);
    return response.data;
  } catch (error) {
    throw error.response?.data || { error: 'Failed to fetch demo request statistics' };
  }
};

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  createDemoRequest,
  getAvailableTimeSlots,
  getAllDemoRequests,
  getDemoRequestById,
  updateDemoRequest,
  deleteDemoRequest,
  getDemoRequestStats
};

